<div class="modal-header">
  <h6 class="modal-title bg-modal">{{ header | translate}}</h6>
  <div type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </div>
</div>
<div class="modal-body">
  {{ message | translate}}

  <div class="row pt-3">
    <div class="form-group col-md-6">
      <button type="submit" class="btn btn-danger btn-block" (click)="confirm()">
        {{ 'CONFIRM' | translate}}
      </button>
    </div>
    <div class="form-group col-md-6">
      <button type="submit" class="btn btn-secondary btn-block" (click)="closeModal()">
        {{ 'CANCEL' | translate}}
      </button>
    </div>

  </div>
</div>